import { render, staticRenderFns } from "./AccountColleague.vue?vue&type=template&id=22e8003b&scoped=true"
import script from "./AccountColleague.vue?vue&type=script&lang=js"
export * from "./AccountColleague.vue?vue&type=script&lang=js"
import style0 from "./AccountColleague.vue?vue&type=style&index=0&id=22e8003b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8003b",
  null
  
)

export default component.exports